import { render } from "./CdaContentSideBarGrouped.vue?vue&type=template&id=7764b6da&scoped=true"
import script from "./CdaContentSideBarGrouped.vue?vue&type=script&lang=js"
export * from "./CdaContentSideBarGrouped.vue?vue&type=script&lang=js"

import "./CdaContentSideBarGrouped.vue?vue&type=style&index=0&id=7764b6da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7764b6da"]])

export default __exports__